import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';

import { IonicImports } from 'src/app/material-imports.module';
import { NgxTranslateModule } from 'src/app/translate.module';







import { TitleWithChipsComponent } from '../title-with-chips/title-with-chips.component';
import { MenuBarComponent } from './menu-bar.component';
import { NotificationComponent } from './notification/notification.component';
import { ExportImportNotificationComponent } from './export-import-notification/export-import-notification.component';


@NgModule({
  imports: [
    VirtualScrollerModule,
    CommonModule,
    RouterModule,
    IonicImports,
    ReactiveFormsModule,
    FormsModule,
    NgxTranslateModule,
    TitleWithChipsComponent,
    ExportImportNotificationComponent,
    MenuBarComponent, NotificationComponent
  ],
  exports: [MenuBarComponent]
})
export class MenuBarModule { }
